<template>
    <div
        class="mb-5"
    >
        <div>
            <label
                v-if="label"
                :for="id"
                class="block font-medium"
            >
                {{ label }}
                <span
                    class="text-red-500"
                    v-if="vuelidate.required && vuelidate.required !== false"
                >
                    *
                </span>
            </label>
            <input
                :id="id"
                :name="id"
                type="text"
                class="input text empty w-full bg-transparent border-none appearance-none outline-none"
                @blur="vuelidate.$touch"
                :placeholder="placeholder"
                :value="value"
                @input="handleInput"
            />
            <div class="baseline border-b border-b-gray-200"></div>
        </div>
        <div
            class="input-errors"
            :class="{ 'text-red-500': vuelidate.$error }"
            v-for="error of vuelidate.$errors"
            :key="error.$uid"
        >
            <div class="error-msg">{{ error.$message }}</div>
        </div>
        <div
            v-if="$slots['sub-input']"
            class="mt-3"
        >
            <slot name="sub-input"></slot>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        vuelidate: {
            type: Object,
            required: true,
        },
        id: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            default: () => "",
        },
        placeholder: {
            type: String,
            default: () => "",
        },
        value: {
            type: String,
            default: () => '',
        }
    },
    methods: {
        handleInput(e) {
            this.$emit('input', e);
        }
    }
}
</script>